import { ReactNode } from "react";
import { cn } from "../../../utils/class-names";
import { tv } from "tailwind-variants";

interface NavLinkContainerProps {
  className?: string;
  children?: ReactNode;
}

export function NavLinkContainer({
  className,
  children,
}: NavLinkContainerProps): JSX.Element {
  return (
    <div className={cn("flex flex-col gap-10 items-stretch", className)}>
      {children}
    </div>
  );
}

export const navLink = tv({
  base: "flex items-center gap-2.5 text-xl font-medium text-shale-300",
  variants: {
    isActive: {
      true: "text-white",
    },
  },
});
